export const categories = [
  {
    slug: 'hanhua',
    name: '汉化版',
    description: '精选汉化Galgame资源，中文无障碍畅玩',
    icon: 'ri-translate',
    count: 1280,
  },
  {
    slug: 'riwen',
    name: '日文原版',
    description: '原汁原味日文原版Galgame游戏',
    icon: 'ri-earth-line',
    count: 960,
  },
  {
    slug: 'buding',
    name: '补丁包',
    description: '汉化补丁、修正补丁、免CD补丁合集',
    icon: 'ri-tools-fill',
    count: 560,
  },
  {
    slug: 'gonglve',
    name: '攻略合集',
    description: '全路线攻略、隐藏要素、CG存档',
    icon: 'ri-book-open-line',
    count: 340,
  },
  {
    slug: 'quanlingyu',
    name: '全年龄',
    description: '适合所有年龄段的Galgame作品',
    icon: 'ri-user-smile-line',
    count: 420,
  },
  {
    slug: 'remake',
    name: '重制版',
    description: '高清重制、全语音版经典Galgame',
    icon: 'ri-refresh-line',
    count: 180,
  },
  {
    slug: 'tongren',
    name: '同人佳作',
    description: '优秀同人社团出品的Galgame作品',
    icon: 'ri-group-line',
    count: 650,
  },
  {
    slug: 'xinyou',
    name: '新作速递',
    description: '最新发布的Galgame资源，第一时间更新',
    icon: 'ri-rocket-line',
    count: 230,
  },
];

export const allCategories = categories;

export function getCategoryBySlug(slug: string) {
  return categories.find(c => c.slug === slug);
}